import React,{Component} from 'react';
import './Headbar.css';

class Headbar extends Component
{
    render()
    {
        return (
            <div id="HeadBar"></div>
        );
    }
}

export default Headbar;



// WEBPACK FOOTER //
// ./src/components/Headbar/Headbar.js